import * as types from './actionTypes';
import axios from 'axios';
import { getHeader } from '../helper';

function activatePromocodeRequest() {
  return {
    type: types.ACTIVATE_PROMOCODE_REQUEST
  }
}

function activatePromocodeSuccess(data) {
  return {
    type: types.ACTIVATE_PROMOCODE_SUCCESS,
    data
  }
}

function activatePromocodeError(messages) {
  return {
    type: types.ACTIVATE_PROMOCODE_FAILURE,
    messages
  }
}

export function activatePromocode(params, callback) {
  return function(dispatch) {
    dispatch(activatePromocodeRequest());

    return axios.post(`${window.siteUrl}/api/v1/activate_promocode/`, {
        code: params.promocode
      },
      {
        headers: getHeader()
      }  
    )
    .then(function(response) {
      if(callback) {
        callback(response);
      }
      if(response.data.status) {
        dispatch(activatePromocodeSuccess(response.data));
      } else {
        dispatch(activatePromocodeError(response.data));
      }
    })
    .catch(function(error) {
      if (error.response) {
        let err = error.response;
        console.error("promocodeError", err.data, err.status, err.headers);
        callback(err);
        dispatch(activatePromocodeError(err.data));
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/promocodeActions.js